import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "rolesAndPermissionsTool",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "rolesAndPermissionsTool" */ "./RolesAndPermissionsTool"
      ),
      import(
        /* webpackChunkName: "rolesAndPermissionsTool" */ "Tooling/routes/RolesAndPermissionsTool/modules/RolesAndPermissionsToolModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "rolesAndPermissionsTool",
          reducer,
        });
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
  childRoutes: [],
});
